import type { OrgFieldConfig } from "@/api/org_field_config.tsx"
import { FieldType } from "@/api/org_field_config.tsx"

/** True when the org has an active field config for `field_name` on the deduction detail page. */
export function deduction_detail_org_field_active(configs: OrgFieldConfig[], field_name: string): boolean {
  return configs.some(
    (c) => c.is_active && c.field_name === field_name && c.table_contexts.includes("deduction_detail"),
  )
}

if (import.meta.vitest) {
  const { describe, expect, it } = import.meta.vitest

  describe("deduction_detail_org_field_active", () => {
    it("returns false when no matching config", () => {
      expect(deduction_detail_org_field_active([], "admin_fee")).toBe(false)
      expect(
        deduction_detail_org_field_active(
          [
            {
              id: "1",
              org_id: "o",
              field_name: "other",
              field_type: FieldType.Text,
              display_name: "Other",
              display_order: 0,
              is_active: true,
              table_contexts: ["deduction_detail"],
              created_at: "",
              updated_at: "",
            },
          ],
          "admin_fee",
        ),
      ).toBe(false)
    })

    it("returns true when active admin_fee includes deduction_detail", () => {
      expect(
        deduction_detail_org_field_active(
          [
            {
              id: "1",
              org_id: "o",
              field_name: "admin_fee",
              field_type: FieldType.Number,
              display_name: "Admin fee",
              display_order: 0,
              is_active: true,
              table_contexts: ["deduction_detail"],
              created_at: "",
              updated_at: "",
            },
          ],
          "admin_fee",
        ),
      ).toBe(true)
    })

    it("returns false when inactive or wrong context", () => {
      expect(
        deduction_detail_org_field_active(
          [
            {
              id: "1",
              org_id: "o",
              field_name: "admin_fee",
              field_type: FieldType.Number,
              display_name: "Admin fee",
              display_order: 0,
              is_active: false,
              table_contexts: ["deduction_detail"],
              created_at: "",
              updated_at: "",
            },
          ],
          "admin_fee",
        ),
      ).toBe(false)
      expect(
        deduction_detail_org_field_active(
          [
            {
              id: "1",
              org_id: "o",
              field_name: "admin_fee",
              field_type: FieldType.Number,
              display_name: "Admin fee",
              display_order: 0,
              is_active: true,
              table_contexts: ["deduction_table"],
              created_at: "",
              updated_at: "",
            },
          ],
          "admin_fee",
        ),
      ).toBe(false)
    })
  })
}
